/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindLeadsBatchWithDocumentStatsRequest
 */
export interface FindLeadsBatchWithDocumentStatsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FindLeadsBatchWithDocumentStatsRequest
     */
    lead_ids: Array<string>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithDocumentStatsRequest interface.
 */
export function instanceOfFindLeadsBatchWithDocumentStatsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_ids" in value;

    return isInstance;
}

export function FindLeadsBatchWithDocumentStatsRequestFromJSON(json: any): FindLeadsBatchWithDocumentStatsRequest {
    return FindLeadsBatchWithDocumentStatsRequestFromJSONTyped(json, false);
}

export function FindLeadsBatchWithDocumentStatsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithDocumentStatsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
    };
}

export function FindLeadsBatchWithDocumentStatsRequestToJSON(value?: FindLeadsBatchWithDocumentStatsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_ids': value.lead_ids,
    };
}

